import api from "./api";

const employeeService = {
  getAll: (params = {}) => api.get("/employees", { params }),
  getById: (id) => api.get(`/employees/${id}`),
  create: (data) => api.post("/employees", data),
  update: (id, data) => api.put(`/employees/${id}`, data),
  remove: (id) => api.delete(`/employees/${id}`),
  importEmployees: (joiningDate, defaultDepartment, employees) =>
    api.post("/employees/import", {
      joiningDate,
      defaultDepartment,
      employees,
    }),
};

export default employeeService;
